import React from 'react';
import { VideoLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingMkvToMp4ConverterConfig } from '@/data/landingConfig/landingMkvToMp4ConverterConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_MkvToMp4Converter } from './schemaObject';

interface Props {}
const MkvToMp4Converter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_MkvToMp4Converter} />
			<VideoLandingTemplate
				data={landingMkvToMp4ConverterConfig}
				funnelLinkService={GenerateLandingLinkService.funnelVideoConverter()}
			/>
		</>
	);
};

export default MkvToMp4Converter;
